<template>
    <el-card class="deposit-refund-history" shadow="never">
        <h5 class="deposit-refund-history__title">Lịch sử xử lý</h5>
        <div class="deposit-refund-history__divider"/>

        <div class="deposit-refund-history__list">
            <article
                v-for="item in history"
                :key="item.id"
                class="deposit-refund-history__item"
            >
                <header class="deposit-refund-history__item-header">
                    <span class="deposit-refund-history__item-title">{{ item.title }}</span>
                </header>

                <div class="deposit-refund-history__item-body">
                    <div class="deposit-refund-history__row">
                        <span class="deposit-refund-history__label">Thời gian:</span>
                        <span class="deposit-refund-history__value">{{ item.changedAt || "—" }}</span>
                    </div>

                    <div v-if="item.showRefundReason" class="deposit-refund-history__row">
                        <span class="deposit-refund-history__label">Lý do hoàn cọc:</span>
                        <span class="deposit-refund-history__value">{{ item.refundReasonLabel }}</span>
                    </div>

                    <div v-if="item.note" class="deposit-refund-history__row">
                        <span class="deposit-refund-history__label">Ghi chú:</span>
                        <span class="deposit-refund-history__value deposit-refund-history__note">
                            {{ item.note }}
                        </span>
                    </div>
                </div>
            </article>

            <p v-if="!history.length" class="deposit-refund-history__empty">
                Chưa có lịch sử xử lý.
            </p>
        </div>
    </el-card>
</template>

<script>
export default {
    name: "DepositRefundHistoryTimeline",
    props: {
        history: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.deposit-refund-history {
    border-radius: 10px;
    border: 1px solid #ebedf3;
    min-height: 320px;
}

.deposit-refund-history :deep(.el-card__body) {
    padding: 20px 22px 24px;
}

.deposit-refund-history__title {
    margin: 0 0 12px;
    font-size: 15px;
    font-weight: 700;
    color: #181c32;
}

.deposit-refund-history__divider {
    height: 1px;
    background: #ebedf3;
    margin-bottom: 16px;
}

.deposit-refund-history__list {
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    padding-right: 4px;
}

.deposit-refund-history__item {
    border: 1px solid #e4e6ef;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 14px;
    background: #fff;
}

.deposit-refund-history__item-header {
    padding: 12px 14px;
    border-bottom: 1px solid #f1f3f8;
    background: #faf9fc;
}

.deposit-refund-history__item-title {
    color: #5d04b0;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.45;
}

.deposit-refund-history__item-body {
    padding: 12px 14px 14px;
}

.deposit-refund-history__row {
    display: grid;
    grid-template-columns: 118px 1fr;
    gap: 8px 12px;
    font-size: 13px;
    margin-bottom: 8px;
}

.deposit-refund-history__row:last-child {
    margin-bottom: 0;
}

.deposit-refund-history__label {
    color: #7e8299;
    font-weight: 600;
}

.deposit-refund-history__value {
    color: #3f4254;
    word-break: break-word;
}

.deposit-refund-history__note {
    white-space: pre-wrap;
}

.deposit-refund-history__empty {
    margin: 0;
    font-size: 13px;
    color: #a1a5b7;
    text-align: center;
    padding: 24px 0;
}
</style>
